import actionTypes from './actionTypes';

export const initialState = {
  content: {},
  meta: {},
  tags: [],
  relatedCommunities: [],
};

export default function ArticleReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_ARTICLE_CONTENT_SUCCESS: {
      return {
        ...state,
        content: action.content,
      };
    }
    case actionTypes.FETCH_ARTICLE_META_SUCCESS: {
      return {
        ...state,
        meta: action.meta,
      };
    }
    case actionTypes.FETCH_ARTICLE_TAGS_SUCCESS: {
      return {
        ...state,
        tags: action.tags,
      };
    }
    case actionTypes.FETCH_ARTICLE_RELATED_COMMUNITIES_SUCCESS: {
      return {
        ...state,
        relatedCommunities: action.relatedCommunities,
      };
    }
  }
  return state;
}
